import React from 'react'
import PropTypes from 'prop-types'
import { Image, Flex, Box } from '@chatterbug/aaron'

import iconBookmarked from './assets/bookmarked.svg'

const ICONS = {
  bookmarked: iconBookmarked,
}

const ToggledStateLabel = ({
  icon,
  label,
  labelVariant = 'text.tinyTitle',
  labelDisplay,
  ...rest
}) => {
  return (
    <Flex alignItems="center" {...rest}>
      <Image src={ICONS[icon]} height="16px" alt={label} />
      <Box variant={labelVariant} ml="1x" color="blue42" display={labelDisplay}>
        {label}
      </Box>
    </Flex>
  )
}
ToggledStateLabel.propTypes = {
  icon: PropTypes.oneOf(['bookmarked']).isRequired,
  label: PropTypes.string.isRequired,
  labelVariant: PropTypes.string,
  labelDisplay: PropTypes.object,
}

export default ToggledStateLabel
